import i18n from 'i18n'

export const INITIAL_STATE = {
  barcode: '',
  batch: '',
  begin: null,
  boningoutinspectionnum: '',
  car: '',
  nrProtocols: '',
  cargo: '',
  destinationcnpj: '',
  end: null,
  invoice: '',
  fazCode: '',
  ie: '',
  order: '',
  sku: '',
  producerdoc: '',
  propname: '',
  producername: '',
  sequential: '',
  slaughtersif: '',
  typeDate: 'invoiceat',
  trackable: 'all',
  typeVisible: 'all',
  limit: null,
  page: 0,
  column: 'order',
  direction: 'asc',
  totalItems: 0,
  totalPages: 0,
  stockcnpj: '',
  productionType: 'all',
  invoiceType: '',
  processedSIF: '',
  opNumberProcessed: '',
  years: [],
  months: [],
  accessGroupsFilter: [],
  industryGroupsFilter: [],
  suitable: '',
  bioma: '',
  state: '',
  city: '',
  boningoutindustrycnpj: '',
  analyze: '',
  protocols: 'all',
  containerNumber: '',
  clientOrderNumber: '',
  mainOrderNumber: '',
  countryFinalDestination: '',
  shippingMarkNumber: '',
  purchaseContract: '',
  purchaseOrder: ''
}

export const INITIAL_STATE_ERRORS = {
  barcode: '',
  batch: '',
  begin: null,
  boningoutinspectionnum: '',
  car: '',
  nrProtocols: '',
  cargo: '',
  destinationcnpj: '',
  end: null,
  invoice: '',
  ie: '',
  order: '',
  sku: '',
  producerdoc: '',
  propname: '',
  producername: '',
  sequential: '',
  slaughtersif: '',
  typeDate: '',
  trackable: '',
  typeVisible: '',
  stockcnpj: '',
  productionType: '',
  invoiceType: '',
  processedSIF: '',
  opNumberProcessed: '',
  years: '',
  months: '',
  accessGroupsFilter: '',
  industryGroupsFilter: '',
  suitable: '',
  bioma: '',
  state: '',
  city: '',
  analyze: '',
  boningoutindustrycnpj: '',
  fazCode: '',
  protocols: '',
  containerNumber: '',
  clientOrderNumber: '',
  mainOrderNumber: '',
  countryFinalDestination: '',
  shippingMarkNumber: '',
  purchaseContract: '',
  purchaseOrder: ''
}

const objDates = [
  { title: i18n.t('common:invoice'), value: 'invoiceat' },
  { title: i18n.t('common:order'), value: 'orderedat' },
  { title: i18n.t('common:slaughter'), value: 'slaughteredat' },
  { title: i18n.t('common:production'), value: 'boningoutat' },
  { title: i18n.t('common:validity'), value: 'expiresat' }
]

export const typesDate = (filterType?: string, isAdmin?: boolean) => {
  if (filterType === 'distribution' && !isAdmin) {
    return objDates.filter(i =>
      ['invoiceat', 'orderedat', 'boningoutat'].includes(i.value)
    )
  }
  // Para o painel Sampco de propriedades, esconder filtros de Abate e Validade
  if (filterType === 'distProperties' && !isAdmin) {
    return objDates.filter(i =>
      ['invoiceat', 'orderedat', 'boningoutat'].includes(i.value)
    )
  }
  return objDates
}

export const suitableType = () => [
  // { title: i18n.t('common:all'), value: 'all' },
  { title: i18n.t('common:fit'), value: 'true' },
  { title: i18n.t('common:notFit'), value: 'false' }
]

export const trackables = () => [
  { title: i18n.t('common:tracked'), value: '2' },
  { title: i18n.t('common:trackedPartially'), value: '1' },
  { title: i18n.t('common:notTracked'), value: '3' },
  { title: i18n.t('common:pending'), value: '0' },
  { title: i18n.t('common:all'), value: 'all' }
]
export const typeVisible = () => [
  { title: i18n.t('common:all'), value: 'all' },
  { title: i18n.t('common:inNature'), value: 'innatura' },
  { title: i18n.t('common:industrialized'), value: 'processed' }
]
export const protocols = () => [
  { title: i18n.t('certification:all'), value: 'all' },
  { title: i18n.t('certification:cfv'), value: 'cfv' },
  { title: i18n.t('certification:none'), value: 'none' }
]

export const productionTypeOptions = () => [
  { title: i18n.t('common:all'), value: 'all' },
  // { title: i18n.t('common:processed'), value: 'processed' },
  { title: i18n.t('common:innatura'), value: 'innatura' },
  { title: i18n.t('common:offal'), value: 'offal' }
]

export const productionTypeRadio = () => [
  { title: i18n.t('common:innatura'), value: 'innatura' },
  { title: i18n.t('common:processed'), value: 'processed' },
  { title: i18n.t('common:offal'), value: 'offal' }
]

export const productionTypeRadioRetails = () => [
  { title: i18n.t('common:innatura'), value: 'innatura' },
  { title: i18n.t('common:offal'), value: 'offal' }
]
export const invoiceTypeOptions = () => [
  { title: i18n.t('common:in'), value: 'in' },
  { title: i18n.t('common:out'), value: 'out' }
]

export const biomaTypeOptions = () => [
  { title: i18n.t('common:in'), value: 'in' },
  { title: i18n.t('common:out'), value: 'out' }
]
